// What a failed write can honestly say. A 4xx is the server answering no. Anything
// else (no reply, a 5xx) may have committed: the reply is what got lost, not
// necessarily the write, so "it failed" would be a claim nobody can make (#391).
import { newReviewSessionId } from './gateView';

export const isRefusal = (err) => {
  const status = err?.response?.status;
  return status >= 400 && status < 500;
};

// Where a payment dialog stands after a failed try. `open`: nothing can have been
// recorded. `unknown`: a try got no clear answer, so it may have recorded, and only
// a success ends that: a later refusal can come before the server reads the key.
// `conflict`: the server says an earlier try recorded other details. Nothing leaves
// that: a retry could only hear the same.
export const afterFailedTry = (state, err) => {
  if (state === 'conflict' || err?.response?.status === 409) return 'conflict';
  return state === 'open' && isRefusal(err) ? 'open' : 'unknown';
};

// The key a payment dialog sends on every try, so a retry can't pay twice
// (server/lib/paymentRequests.js). That id's format is what the server accepts.
export const newRequestKey = () => newReviewSessionId();
